/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Teams';
export const TEAM_NAME = 'People and Teams Collective';

export const PLUS_BUTTON = 'add';
export const CREATE_A_TEAM = 'createATeam';
export const INVITE_PEOPLE = 'invitePeople';
export const MEATBALL_DROPDOWN = 'meatballDropdown';

export const PEOPLE_SEARCH_HREF = '/jira/people/search';
